import { put } from 'redux-saga/effects';
import {
  getCompanyDetailsFailed,
  getCompanyDetailsSuccess,
  getCompanyInvoicesFailed,
  getCompanyInvoicesSuccess,
  getConsumptionDetailsFailed,
  getConsumptionDetailsSuccess,
  getEventDetailsFailed,
  getEventDetailsSuccess,
  getInvoicesDetailsFailed,
  getInvoicesDetailsSuccess,
  getLandingPageFailed,
  getLandingPageSuccess,
  getPaymentsForInvoiceFailure,
  getPaymentsForInvoiceSuccess,
  getPreviousTopupsFailed,
  getPreviousTopupsSuccess,
  getUpcomingTopupsFailed,
  getUpcomingTopupsSuccess,
  verifyCompanyFailed,
  verifyCompanySuccess,
} from '../../actions/company';
import {
  COMPANY_PROFILE,
  COMPANY_VERIFY,
  GET_COMPANY_INVOICES,
  GET_CONSUMPTION_DETAILS,
  GET_EVENT_DETAILS,
  GET_INVOICE_DETAILS,
  GET_PAYMENTS_FOR_INVOICE,
  GET_PREVIOUS_TOPUPS,
  GET_UPCOMING_TOPUPS,
  LANDING_PAGE,
} from '../../constants/urls';
import zfetch, {
  METHOD_GET,
  METHOD_POST,
} from '../../pages/common/utils/zfetch';
import { successTitle } from '../../pages/Onboarding/constants';
import { openErrorToast, openSuccessToast } from '../../reducers/uiLogic';

const companyDetails = () => {
  const options = {
    method: METHOD_GET,
  };
  return zfetch(COMPANY_PROFILE, options);
};

export function* getCompanyDetailsSaga() {
  let companyData = {};

  try {
    const response = yield companyDetails();
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    companyData = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getCompanyDetailsFailed(err));
    return;
  }

  yield put(getCompanyDetailsSuccess(companyData));
}

const companyVerification = () => {
  const options = {
    method: METHOD_POST,
  };
  return zfetch(COMPANY_VERIFY, options);
};

export function* getCompanyVerificationSaga() {
  try {
    const response = yield companyVerification();
    const jsonResponse = yield response.json();
    const {
      success,
      data: {
        message: { title = successTitle },
      },
    } = jsonResponse;
    if (success) {
      yield put(openSuccessToast(title));
      yield put(verifyCompanySuccess());
    } else {
      yield put(openErrorToast());
      yield put(verifyCompanyFailed());
    }
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(openErrorToast());
    yield put(verifyCompanyFailed(err));
  }
}

const getHomePage = ({ workspaceId, flowType, startDate, endDate }) => {
  const options = {
    method: METHOD_GET,
    params: {
      workspace_id: workspaceId,
      flow_type: flowType,
      start_date: startDate,
      end_date: endDate,
    },
  };
  return zfetch(LANDING_PAGE, options);
};

export function* getHomePageSaga(action) {
  try {
    const response = yield getHomePage(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    yield put(getLandingPageSuccess(data));
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getLandingPageFailed(err));
    yield put(openErrorToast('Failed to get landing page details!'));
  }
}

const getUpcomingTopups = ({ workspaceId, flowType }) => {
  const options = {
    method: METHOD_GET,
    params: { workspace_id: workspaceId, flow_type: flowType },
  };

  return zfetch(GET_UPCOMING_TOPUPS, options);
};

export function* getUpcomingTopupsSaga(action) {
  try {
    const response = yield getUpcomingTopups(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    yield put(getUpcomingTopupsSuccess(data));
  } catch (error) {
    let err = error;

    if (error.response) {
      err = yield err.response;
    }
    yield put(getUpcomingTopupsFailed(err));
  }
}

const getPreviousTopups = ({ workspaceId, flowType }) => {
  const options = {
    method: METHOD_GET,
    params: { workspace_id: workspaceId, flow_type: flowType },
  };

  return zfetch(GET_PREVIOUS_TOPUPS, options);
};

export function* getPreviousTopupsSaga(action) {
  try {
    const response = yield getPreviousTopups(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    yield put(getPreviousTopupsSuccess(data));
  } catch (error) {
    let err = error;

    if (error.response) {
      err = yield err.response;
    }
    yield put(getPreviousTopupsFailed(err));
  }
}

const getEventDetails = ({ programId, eventId }) => {
  const options = {
    method: METHOD_GET,
    params: { program_id: programId, event_id: eventId },
  };
  return zfetch(GET_EVENT_DETAILS, options);
};

export function* getEventDetailsSaga(action) {
  let eventData = {};

  try {
    const response = yield getEventDetails(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    eventData = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getEventDetailsFailed(err));
    yield put(openErrorToast('Failed to get event details'));
    return;
  }

  yield put(getEventDetailsSuccess(eventData));
}

const getConsumptionDetails = ({ startDate, endDate }) => {
  const options = {
    method: METHOD_GET,
    params: { start_date: startDate, end_date: endDate },
  };
  return zfetch(GET_CONSUMPTION_DETAILS, options);
};

export function* getConsumptionDetailsSaga(action) {
  let ordersData = {};

  try {
    const response = yield getConsumptionDetails(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    ordersData = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getConsumptionDetailsFailed(err));
    yield put(openErrorToast('Failed to get consumption orders'));
    return;
  }

  yield put(getConsumptionDetailsSuccess(ordersData));
}

const getCompanyInvoices = ({ flowType }) => {
  const options = {
    method: METHOD_GET,
    params: { flow_type: flowType },
  };
  return zfetch(GET_COMPANY_INVOICES, options);
};

export function* getCompanyInvoicesSaga(action) {
  let invoiceData = {};

  try {
    const response = yield getCompanyInvoices(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    invoiceData = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getCompanyInvoicesFailed(err));
    yield put(openErrorToast('Failed to get statement of consumptions data'));
    return;
  }

  yield put(getCompanyInvoicesSuccess(invoiceData));
}

const getInvoiceDetails = ({ startDate, endDate, flowType }) => {
  const options = {
    method: METHOD_GET,
    params: { start_date: startDate, end_date: endDate, flow_type: flowType },
  };
  return zfetch(GET_INVOICE_DETAILS, options);
};

export function* getInvoiceDetailsSaga(action) {
  let invoiceDetails = {};

  try {
    const response = yield getInvoiceDetails(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    invoiceDetails = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getInvoicesDetailsFailed(err));
    yield put(openErrorToast('Failed to get consumption statement'));
    return;
  }

  yield put(getInvoicesDetailsSuccess(invoiceDetails));
}

const getPaymentsForInvoice = ({ startDate, endDate, flowType }) => {
  const options = {
    method: METHOD_GET,
    params: { start_date: startDate, end_date: endDate, flow_type: flowType },
  };
  return zfetch(GET_PAYMENTS_FOR_INVOICE, options);
};

export function* getPaymentsForInvoiceSaga(action) {
  let invoicePayments = {};

  try {
    const response = yield getPaymentsForInvoice(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    invoicePayments = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getPaymentsForInvoiceFailure(err));
    yield put(
      openErrorToast('Failed to get payments for consumption statement'),
    );
    return;
  }

  yield put(getPaymentsForInvoiceSuccess(invoicePayments));
}
